<template>
  <a :href="signupURL" class="WBMBigButton m-primary">Sign up</a>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import { getSignupURL } from "@/utils/urls";

@Component({})
export default class SignupButton extends Vue {
  get signupURL(): string {
    return getSignupURL();
  }
}
</script>

<style scoped lang="scss"></style>
